import React, { PureComponent } from 'react';
import { toast } from 'react-toastify';

export const DEFAULT_EXTENSIONS = {
  images: ['png', 'gif', 'jpeg', 'jpg'],
  documents: ['doc', 'docx', 'txt'],
  sheets: ['xls', 'xlsx', 'csv'],
  zips: ['zip', 'rar', '7zip'],
  get all(): string[] {
    if (!(this as any)._all) {
      (this as any)._all = [...this.images, ...this.documents, ...this.sheets, ...this.zips];
    }

    return (this as any)._all;
  },
};

interface IProps {
  extensions?: string[]; //jpg, png e etc
}

export default class FileSelector extends PureComponent<IProps, {}> {
  static defaultProps: Partial<IProps> = {
    extensions: DEFAULT_EXTENSIONS.all,
  };

  style = { display: 'none' };
  inputRef: HTMLInputElement;
  resolve: (file: File) => void;

  componentDidMount() {
    window.addEventListener('focus', this.windowFocus);
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.windowFocus);
  }

  windowFocus = () => {
    setTimeout(() => {
      if (!this.resolve) return;
      this.resolve(null);
    }, 500);
  };

  open = async (): Promise<File> => {
    this.inputRef.click();
    return new Promise<File>((resolve) => (this.resolve = resolve));
  };

  onFileSelected = () => {
    const { extensions } = this.props;

    if (!this.inputRef.files.length) {
      this.resolve(null);
      return;
    }

    const file = this.inputRef.files[0];
    this.inputRef.value = null;

    const regexp = new RegExp(`.(${extensions.join('|')})$`, 'gi');

    if (!regexp.test(file.name)) {
      toast.error(`Apenas: ${extensions.join(', ')}`);
      return;
    }

    this.resolve(file);
  };

  getRef = (ref: any) => {
    this.inputRef = ref;
  };

  render() {
    const { extensions } = this.props;

    return <input type='file' style={this.style} ref={this.getRef} onChange={this.onFileSelected} accept={`.${extensions.join(',.')}`} />;
  }
}
